export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/formatNumerals.js
// module id = mUgz
// module chunks = 0